import { FormControl } from "@mui/material";
import { useState } from "react";

import '../style.css';
import { useForm } from '../../../hooks/useForm';
import { Message } from "../../../components/Message";
import { AddClientForm } from "./AddClientForm";
import { messagesEdit } from "../../../helpers/clientsMessage";

export const EditClientForm = ({ data }) => {
    const [formValues, handleInputChange, reset] = useForm(data[0]);

    const [isCreate, setIsCreate] = useState(false);
    const [body, setBody] = useState({});

    const handleSubmit = (e) => {
        e.preventDefault();
        const contactsToString = (typeof formValues.contacts === 'string') ? formValues.contacts : JSON.stringify(formValues.contacts)
        setBody({...formValues, 'contacts' : contactsToString})
        setIsCreate(!isCreate)
    }

    return (
        <section className="section_formClient">
            <FormControl component='form' className="formClient_container" onSubmit={handleSubmit}>
                <AddClientForm title='Editar ' formValues={formValues} handleInputChange={handleInputChange} reset={reset} />
                {isCreate && <Message reset={reset} setIsCreate={setIsCreate} method='PUT' body={body} messages={messagesEdit} />}
            </FormControl>
        </section>
    )
}
